export const GET_PARAMS_DATA_REQUEST = "DevicesParams/GET_PARAMS_DATA_REQUEST";
export const GET_PARAMS_DATA_SUCCESS = "DevicesParams/GET_PARAMS_DATA_SUCCESS";
export const GET_PARAMS_DATA_FAILURE = "DevicesParams/GET_PARAMS_DATA_FAILURE";